import { Component, OnInit, HostListener,EventEmitter,Injectable } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router, ActivatedRoute, NavigationExtras, RouterOutlet, Routes } from '@angular/router';
import { DwRoutingMessageService, AG_GRID_FW_COMPONENT, DwNewRouteKeyService } from '@webdpt/framework';
import { FxDapHttpClient } from 'app/implementation/shared/fx-http-client';
import { TranslateService } from '@ngx-translate/core';
import { fromEvent } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class FxUrlServiceService implements OnInit{
  //申明发射事件
  public eventEmit:any;

  constructor(
    public http: FxDapHttpClient,
    public router: DwNewRouteKeyService,
    protected route: ActivatedRoute
    ) {
    this.eventEmit = new EventEmitter();
  }

  ngOnInit(): void {
    
  }

  getDns(val:any,id:any) {
      //判断入参是否为空值
      if(val === null) {
        return;
      }

        //带id域名
        let urlId = /^(?=^.{3,255}$)(http(s)?:\/\/)?(www\.)?[a-zA-Z0-9][-a-zA-Z0-9]{0,62}(\.[a-zA-Z0-9][-a-zA-Z0-9]{0,62})+(:\d+)*(\/\w+\.\w+)*([\?&]\w+=\w*)*$/,
        //完整域名
        urlDns = /^(?=^.{3,255}$)(http(s)?:\/\/)?(www\.)?[a-zA-Z0-9][-a-zA-Z0-9]{0,62}(\.[a-zA-Z0-9][-a-zA-Z0-9]{0,62})+(:\d+)*(\/\w+\.\w+)*$/,
        //IP地址
        urlIp = /^(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])$/,
        //省www域名
        urlNameDns = /^(?=^.{3,255}$)[a-zA-Z0-9][-a-zA-Z0-9]{0,62}(\.[a-zA-Z0-9][-a-zA-Z0-9]{0,62})+$/,
        //以http或https开头
        urlHttp = /(http|https):\/\/([\w.]+\/?)\S*/;

        let hasHttp = new RegExp(urlHttp,'i');
        if(urlHttp.test(val) === true) {

          let newLink = val.slice(7);
          window.open("http://"+ newLink)
          return;
        }

      let checkedUrl = urlId || urlDns || urlIp || urlNameDns;
      let checkUrl = new RegExp(checkedUrl,'i');
      let text = checkUrl.test(val);
      if(text === true) {
        window.open("http://" + val)
      } else {
        if(id == '') {
          this.router.navigate(['./home/'+ val])
        } else {
          this.router.navigate(['./home/'+ val,{id}])
        }
      }
  }
}
